(() => {
  const body = document.body;
  if (body.classList.contains('template-index')) return;
  let lastY = window.scrollY;
  const update = () => {
    const y = window.scrollY;
    const dy = y - lastY;
    if (Math.abs(dy) > 6) {
      body.dataset.headerHidden = dy > 0 && y > 120 ? 'true' : 'false';
      lastY = y;
    }
  };
  window.addEventListener('scroll', update, { passive: true });
})();
